// Status Filter
export const status = {
	computed: {
		statuses() {
			return this.$store.getters.getUserStatus.map(status => {
				return {
					id: status.id,
					value: status.translated_name
				}
			})
		},
	},

	watch: {
		'statuses.length': {
			handler: function (length) {
				this.options?.filters.find(({key, option}) => {
					if (key === 'status') option.push(...this.statuses)
				})
			},
			immediate: true
		},
	},
	
	mounted() {
		setTimeout(() => {
			this.$store.dispatch('getUserStatus')
		}, 1000)
	}
}

export const employeeFilter = {
	computed: {
		employees() {
			return this.$store.getters.getEmployeeList.map(employee => {
				return {
					id: employee.id,
					value: employee.name
				}
			})
		}
	},
	watch: {
		'employees.length': {
			handler: function (length) {
				this.options?.filters.find(({key, option}) => {
					if (key === 'employees') option.push(...this.employees)
				})
			},
			immediate: true
		},
	},

	mounted() {
		setTimeout(() => {
			this.$store.dispatch('getEmployees')
		}, 1000)
	}
}